/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

import {NoteId, NoteInput} from "../__ignore/schemas";

/**
 * @summary Edit representative note
 */
export const EditRepresentativeNoteBody = NoteInput;

export const EditRepresentativeNoteResponse = zod.void();

/**
 * @summary Remove representative note
 */
export const RemoveRepresentativeNoteResponse = zod.void();

/**
 * @summary Add representative note
 */
export const AddRepresentativeNoteBody = NoteInput;

export const AddRepresentativeNoteResponse = NoteId;
